import {metadaApi} from '@dms/api/base';

import {
  GetWorkshopOverviewApiArg,
  GetWorkshopOverviewApiArgSchema,
  GetWorkshopOverviewApiResponse,
  GetWorkshopOverviewApiResponseSchema,
} from './types';

const normalizeSelection = (values: string[] | undefined) =>
  values?.length ? [...new Set(values)].sort() : undefined;

const normalizeFilters = (filters: GetWorkshopOverviewApiArg) => ({
  branchId: normalizeSelection(filters?.branchId),
  serviceOrderTypeId: normalizeSelection(filters?.serviceOrderTypeId),
  serviceOrderVariantId: normalizeSelection(filters?.serviceOrderVariantId),
});

export const metadaWorkshopOverviewApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getWorkshopOverview: build.query<GetWorkshopOverviewApiResponse, GetWorkshopOverviewApiArg>({
      serializeQueryArgs: ({queryArgs}) => normalizeFilters(queryArgs),
      query: (queryArg) => {
        const params = new URLSearchParams();
        Object.entries(normalizeFilters(queryArg)).forEach(([key, values]) =>
          values?.forEach((value) => params.append(key, value))
        );

        return {
          url: '/service/v1/workshop-overview',
          params,
          queryArg: queryArg ?? {},
        };
      },
      extraOptions: {
        requestSchema: GetWorkshopOverviewApiArgSchema,
        responseSchema: GetWorkshopOverviewApiResponseSchema,
      },
    }),
  }),
});

export const {useGetWorkshopOverviewQuery} = metadaWorkshopOverviewApi;
